interface PriceFormatOptions {
    salePrice: number;
    regularPrice?: number;
    salePercent?: number;
    currency: string;
}

export function calculateSalePercent(salePrice: number, regularPrice: number): number {
    if (regularPrice - salePrice > 0) {
      return ((regularPrice - salePrice) / regularPrice) * 100;
    }
    return 0;
}

export function formatPriceSingleProduct(options: PriceFormatOptions) {
    const { salePrice, regularPrice = 0, salePercent, currency } = options;

    // Calculate sale percent if not provided
    const calculatedSalePercent = salePercent ?? calculateSalePercent(salePrice, regularPrice);

    // Format prices and sale percent
    const formattedsalePrice = new Intl.NumberFormat('en-US', { style: 'currency', currency,  maximumFractionDigits: 0 }).format(salePrice);
    const formattedregularPrice = regularPrice > 0 ? new Intl.NumberFormat('en-US', { style: 'currency', currency,  maximumFractionDigits: 0 }).format(regularPrice) : null;
    const formattedSalePercent = calculatedSalePercent ? `-${calculatedSalePercent.toFixed(0)}%` : null;

    return {
        salePrice: formattedsalePrice,
        regularPrice: formattedregularPrice,
        salePercent: formattedSalePercent
    };
}

export function convertPriceDecimal(price: number | string): string {
    if (typeof price === "number") {
        return price.toFixed(2);
    } else if (typeof price === "string" && !isNaN(Number(price))) {
        return parseFloat(price).toFixed(2);
    } else {
        console.log(`Invalid price ${price} input: must be a number or a numeric string.`);
        return price;
    }
}